import React from 'react';
const steps = ['Consulta le lezioni.', 'Esplora le attività.', 'Utilizza gli strumenti di pianificazione.', 'Prova il materiale nelle tue lezioni.'];
export function Guarantee() {
  return <section className="bg-brand-cream px-4 py-7" data-id="element-82" data-mp="223odrfepfscb">
      <div className="mx-auto max-w-2xl text-center" data-id="element-83" data-mp="221bwl4grtm0b">
        <p className="font-display text-sm font-extrabold uppercase tracking-wide text-brand-green" data-id="element-84" data-mp="1x5d3j3khzftk">
          Il tuo acquisto è protetto al 100%
        </p>

        <div className="mt-2 rounded-xl border-4 border-brand-green/50 bg-white p-4" data-id="element-85" data-mp="14fo2iq7sffry">
          <h2 className="font-display text-lg font-extrabold uppercase leading-tight text-brand-navy sm:text-xl" data-id="element-86" data-mp="14dtf9591nbkp">
            <span aria-hidden="true" data-id="element-87" data-mp="1edu394huyfv8">🛡️</span> Garanzia Soddisfatti o Rimborsati
            di 14 Giorni
          </h2>

          <p className="mt-2 text-[15px] font-medium leading-snug text-brand-graphite" data-id="element-88" data-mp="qnq2d4w20u7x">
            Puoi esplorare ENGLISH TEACHER PRO™ per 14 giorni.
          </p>

          <ul className="mt-2 flex flex-wrap justify-center gap-1.5" data-id="element-89" data-mp="lnbzs2d82cha">
            {steps.map(step => <li key={step} className="rounded border border-brand-green/30 bg-brand-green/10 px-2 py-1 text-[12px] font-semibold leading-tight text-brand-navy" data-id="element-90" data-mp="tymgy5jsxixn">
                {step}
              </li>)}
          </ul>

          <p className="mt-2.5 text-[15px] font-medium leading-snug text-brand-graphite" data-id="element-91" data-mp="12t0t3z91cdcj">
            Se per qualsiasi motivo ritieni che il sistema non sia adatto alle
            tue esigenze, contattaci entro 14 giorni per richiedere il rimborso
            secondo i termini della garanzia.
          </p>
          <p className="mt-1.5 font-display text-base font-extrabold uppercase text-brand-green" data-id="element-92" data-mp="f3oo7bkqqrg1">
            Nessun rischio.
          </p>
        </div>
      </div>
    </section>;
}